<template>
  <div>
    <b-card>
      <b-row>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col>
          <label class="form-control-label" for="example-datepicker"
            >Invoice Date</label
          >
          <b-form-datepicker
            v-model="invoice.date"
            value-as-date
            class="col-sm-12"
            :min="new Date()"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label" for="example-datepicker"
            >Terms</label
          >
          <b-form-datepicker
            v-model="invoice.duedate"
            value-as-date
            class="col-sm-12"
            :min="new Date()"
          ></b-form-datepicker>
          <div class="text-muted mt-2 small">
            <a href="#" @click="setDueDate(15)">15 days</a> |
            <a href="#" @click="setDueDate(30)">30 days</a> |
            <a href="#" @click="setDueDate(45)">45 days</a> |
            <a href="#" @click="setDueDate(90)">90 days</a>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-3">
        <b-col>
          <b>Line Items</b>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="5">
          <label class="form-control-label" for="example-datepicker">
            Product/Service
          </label>
        </b-col>
        <b-col>
          <label class="form-control-label" for="example-datepicker">
            Qty
          </label>
        </b-col>
        <b-col>
          <label class="form-control-label" for="example-datepicker">
            Price
          </label>
        </b-col>
        <b-col style="text-align:right">
          <label class="form-control-label" for="example-datepicker">
            Total
          </label>
        </b-col>
        <b-col>
          &nbsp;
        </b-col>
      </b-row>
      <div v-for="(lineItem, index) in invoice.lineItems" v-bind:key="index">
        <EditLineItem
          :lineItem="lineItem"
          @lineItemChanged="lineItemChanged"
          @deleteLineItem="deleteLineItem"
        />
      </div>
      <a href="#" @click.prevent="addLineItem()">Add</a>
    </b-card>
  </div>
</template>

<script>
import Product from "./Product.vue";
import EditLineItem from "./EditLineItem.vue";

export default {
  components: { Product, EditLineItem },

  data() {
    return {
      invoice: {
        date: new Date(),
        duedate: new Date(),
        terms: "DUEONRECIPT",
        lineItems: [],
      },
    };
  },
  created() {
    if (this.invoice.lineItems.length == 0) this.addLineItem();
  },
  methods: {
    deleteLineItem(index) {
      this.invoice.lineItems.splice(index, 1);
    },
    addLineItem() {
      this.invoice.lineItems.push({
        lineItemId: null,
        index: 0,
        productId: null,
        qty: 1,
      });
    },
    lineItemChanged(lineItem) {
      this.$set(this.invoice.lineItems, lineItem.index, lineItem);
    },
    setDueDate(days) {
      this.invoice.duedate = new Date(this.invoice.date);
      this.invoice.duedate.setDate(this.invoice.duedate.getDate() + days);
    },
  },
};
</script>

<style></style>
